/* eslint-disable */
import _ from 'underscore';
import backbone from 'backbone';
import scheduler from '@bingads-webui-static-legacy/async-scheduler';
import repository from '@bingads-webui-static-legacy/bulk-edit/bulkEdit/bulkEditRepository';
import bulkEditStatus from '@bingads-webui-static-legacy/schema/bulkEdit/status';
var Poller = function (options) {
  this._options = options || ({});
  this.successiveFailureCount = 0;
  this.recurringTask = scheduler.createTask({
    task: _.bind(this._taskIteration, this),
    schedule: this._options.schedule || 2000
  });
  this.recurringTask.on('success', _.bind(this._successHandler, this));
  this.recurringTask.on('error', _.bind(this._errorHandler, this));
};
Poller.prototype.maxSuccessiveFailureCount = 6;
Poller.prototype.start = function (jobModels) {
  this._jobModels = new backbone.Collection(jobModels);
  if (this._getPendingJobs().length > 0) {
    this.recurringTask.start();
  }
  return this;
};
Poller.prototype.stop = function () {
  this.recurringTask.stop();
  return this;
};
Poller.prototype._taskIteration = function () {
  return repository.getJobs(this._getPendingJobs());
};
Poller.prototype._successHandler = function (eventArgs) {
  var self = this;
  this.successiveFailureCount = 0;
  if (eventArgs && eventArgs.data && _.isArray(eventArgs.data)) {
    _.each(eventArgs.data, function (jobData) {
      self._jobModels.get(jobData.Id).set(jobData);
    });
  }
  if (this._options.success && _.isFunction(this._options.success)) {
    this._options.success(this._jobModels);
  }
  if (this._getPendingJobs().length === 0) {
    eventArgs.stopTask();
  }
};
Poller.prototype._errorHandler = function (eventArgs) {
  this.successiveFailureCount++;
  if (this.maxSuccessiveFailureCount <= this.successiveFailureCount) {
    this.recurringTask.stop();
    if (this._options.error && _.isFunction(this._options.error)) {
      this._options.error(eventArgs);
    }
  }
};
Poller.prototype._getPendingJobs = function () {
  return this._jobModels.filter(function (model) {
    return model.get('Status') === bulkEditStatus.inProgress || model.get('Status') === bulkEditStatus.pendingStart || model.get('Status') === 'PendingFileUpload';
  });
};
export default Poller;

